import AboutBtn from "../../../components/sub/AboutBtn";
import SubTitle from "../../../components/sub/SubTitle";

const AboutHistory = () => {
  const history2015 = [
    {
      date: "2015.03",
      title: "주식회사 홍여사세정제 법인설립",
      point: true,
    },
    {
      date: "2015.11",
      date2: "2016.03",
      title: "롯데리조트 · 롯데호텔 · 롯데시티호텔 · 롯데백화점 시공 및 납품",
    },
  ];

  const history2016 = [
    {
      date: "2016.02",
      title: "부산우유, 함안 칠서공단 우유저장탱크 크리닝시공.",
    },
    {
      date: "2016.04",
      title: "두산건설, 관련제품 납품.",
    },
  ];

  const history2017 = [
    {
      date: "2017.03",
      title: "롯데, B2B 계약체결.",
    },
    {
      date: "2017.11",
      title: "사조해표, 식품공장 크리닝시공",
    },
  ];
  const history2018 = [
    {
      date: "2018.03",
      title: "한화 에너지, 전남 영암 태양광(6.5메가) 크리닝시공.",
    },
    {
      date: "2018.04",
      title: "한화 큐셀, 중국 수출.",
    },
    {
      date: "2018.12",
      title: "익산, ㈜하림본사 신축현장 준공 입주 크리닝시공(면적 : 11,336㎡)",
    },
  ];
  const history2019 = [
    {
      date: "2019.05",
      title: "화성 SK매직, 본관 별관 크리닝시공.",
    },
    {
      date: "2019.05",
      title: "서울 워커힐호텔, 내부 수영장 크리닝시공.",
    },
    {
      date: "2019.07",
      title: "서울명동 눈스퀘어쇼핑몰, 에스컬레이트 크리닝시공.",
    },
    {
      date: "2019.07",
      title: "서울 워커힐호텔, 휘트니센타 및 수영장 리모델링 크리닝시공",
    },
    {
      date: "2019.08",
      title: "홍콩 ‘밍상사’, 제품수출.",
    },
  ];
  const history2020 = [
    {
      date: "2020.01",
      title: "현대중공업, 제품공급 등록 및 납품.",
    },
    {
      date: "2020.02",
      title: "한화 워터피아, 각종설비 유지보수 관련제품 납품.",
    },
    {
      date: "2020.03",
      title: "군산시 현대건설기계, 사옥 건물외벽 크리닝시공",
    },
    {
      date: "2020.04",
      title: "전남 순천대학교 각종 현판복원 및 교내시설 크리닝시공",
    },
    {
      date: "2020.07",
      title: "Kainos Bio Chemical Co., Ltd. 설립",
      point: true,
    },
  ];
  const history2021 = [
    {
      date: "2021.06",
      title: "김해시 대단지 아파트 제품 대량납품",
    },
  ];
  const history2022 = [
    {
      date: "2022.04",
      title: "전남영암 대불공단, 한화큐셀의 태양광판넬 6.5메가 크리닝시공",
    },
  ];

  return (
    <>
      <SubTitle
        src={"/images/subTitle2.webp"}
        title={"회사연혁 및 업력"}
        eng={"About us"}
      />
      <AboutBtn id={1} />
      <div className="relative w-full h-full mx-auto pt-14 lg:pt-28 xl:pt-36">
        <div
          id="title"
          className="relative w-full h-fit text-center mb-10 xl:mb-14 "
        >
          <h3 className="text-center">(주)카이노스바이오케미칼 연혁 및 업력</h3>
          <p className="text-primary my-5 lg:text-lg">- Company History -</p>
        </div>
        <div className="relative w-full h-full bg-[url('../public/images/aboutBg1.webp')] bg-contain lg:bg-cover bg-left-top pt-16 pb-5 lg:pb-0 lg:pt-28 px-4 lg:px-2">
          <div className="max-w-[1800px] mx-auto text-left text-white">
            <div className=" absolute left-0 top-0">
              <img
                src="/images/aboutLeft.webp"
                alt="카이노스 바이오케미칼 회사연혁 장식 이미지"
                className=" relative object-contain w-full h-auto max-w-44 lg:max-w-none"
              />
            </div>
            <div
              id="2015"
              className="relative w-full h-fit max-h-72 py-8 border-b-2 border-dotted"
              data-aos="fade-up"
            >
              <h3 className="text-center">2015</h3>
              <div className="relative w-full grid lg:grid-cols-3 mt-5">
                <div></div>
                <div className="col-span-2">
                  {history2015.map((v, i) => (
                    <div className="mt-3 flex gap-2 items-center">
                      <div className="w-fit h-fit py-1 px-5">
                        <small className="text-base">
                          {v.date}
                          {v.date2 ? "~" : ""}
                          {v.date2 ? <br /> : ""}
                          {v.date2 ? v.date2 : ""}
                        </small>
                      </div>
                      <p>{v.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              id="2016"
              className="relative w-full h-fit max-h-72 py-8 border-b-2 border-dotted"
              data-aos="fade-up"
            >
              <h3 className="text-center">2016</h3>
              <div className="relative w-full grid lg:grid-cols-3 mt-5">
                <div></div>
                <div className="col-span-2">
                  {history2016.map((v, i) => (
                    <div className="mt-3 flex gap-2 items-center">
                      <div className="w-fit h-fit py-1 px-5">
                        <small className="text-base">{v.date}</small>
                      </div>
                      <p>{v.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              id="2017"
              className="relative w-full h-fit max-h-72 py-8 border-b-2 border-dotted"
              data-aos="fade-up"
            >
              <h3 className="text-center">2017</h3>
              <div className="relative w-full grid lg:grid-cols-3 mt-5">
                <div></div>
                <div className="col-span-2">
                  {history2017.map((v, i) => (
                    <div className="mt-3 flex gap-2 items-center">
                      <div className="w-fit h-fit py-1 px-5">
                        <small className="text-base">{v.date}</small>
                      </div>
                      <p>{v.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              id="2018"
              className="relative w-full h-fit py-8 border-b-2 border-dotted"
              data-aos="fade-up"
            >
              <h3 className="text-center">2018</h3>
              <div className="relative w-full grid lg:grid-cols-3 mt-5">
                <div></div>
                <div className="col-span-2">
                  {history2018.map((v, i) => (
                    <div className="mt-3 flex gap-2 items-center">
                      <div className="w-fit h-fit py-1 px-5">
                        <small className="text-base">{v.date}</small>
                      </div>
                      <p>{v.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              id="2019"
              className="relative w-full h-fit py-8 border-b-2 border-dotted"
              data-aos="fade-up"
            >
              <h3 className="text-center">2019</h3>
              <div className="relative w-full grid lg:grid-cols-3 mt-5">
                <div></div>
                <div className="col-span-2">
                  {history2019.map((v, i) => (
                    <div className="mt-3 flex gap-2 items-center">
                      <div className="w-fit h-fit py-1 px-5">
                        <small className="text-base">{v.date}</small>
                      </div>
                      <p>{v.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              id="2020"
              className="relative w-full h-fit py-8 border-b-2 border-dotted"
              data-aos="fade-up"
            >
              <h3 className="text-center">2020</h3>
              <div className="relative w-full grid lg:grid-cols-3 mt-5">
                <div></div>
                <div className="col-span-2">
                  {history2020.map((v, i) => (
                    <div className="mt-3 flex gap-2 items-center">
                      <div className="w-fit h-fit py-1 px-5">
                        <small className="text-base">{v.date}</small>
                      </div>
                      <p>{v.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              id="2021"
              className="relative w-full h-fit py-8 border-b-2 border-dotted"
              data-aos="fade-up"
            >
              <h3 className="text-center">2021</h3>
              <div className="relative w-full grid lg:grid-cols-3 mt-5">
                <div></div>
                <div className="col-span-2">
                  {history2021.map((v, i) => (
                    <div className="mt-3 flex gap-2 items-center">
                      <div className="w-fit h-fit py-1 px-5">
                        <small className="text-base">{v.date}</small>
                      </div>
                      <p>{v.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              id="2022"
              className="relative w-full h-fit pt-8 pb-16 lg:pb-32"
              data-aos="fade-up"
            >
              <h3 className="text-center">2022</h3>
              <div className="relative w-full grid lg:grid-cols-3 mt-5">
                <div></div>
                <div className="col-span-2">
                  {history2022.map((v, i) => (
                    <div className="mt-3 flex gap-2 items-center">
                      <div className="w-fit h-fit py-1 px-5">
                        <small className="text-base">{v.date}</small>
                      </div>
                      <p>{v.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutHistory;
